// Field types available in the form builder
export const FIELD_TYPES = [
  { value: 'text', label: 'Text Input' },
  { value: 'number', label: 'Number Input (Integer)' },
  { value: 'textarea', label: 'Text Area' },
  { value: 'richtext', label: 'Rich Text Area (Formatted)' },
  { value: 'email', label: 'Email' },
  { value: 'date', label: 'Date Picker' },
  { value: 'select', label: 'Dropdown Select' },
  { value: 'dropdown_list', label: 'Dropdown (Predefined List)' },
  { value: 'radio', label: 'Radio Buttons' },
  { value: 'checkbox', label: 'Single Checkbox' },
  { value: 'checkbox_group', label: 'Checkbox Group' },
  { value: 'array', label: 'Repeatable List (Name/Date)' },
  { value: 'repeatable_group', label: 'Repeatable Group (Multiple Fields)' },
  { value: 'file', label: 'File Upload' },
];

// Condition operators for dependent fields
export const CONDITION_OPERATORS = [
  { value: 'equals', label: 'Equals' },
  { value: 'not_equals', label: 'Does Not Equal' },
  { value: 'not_empty', label: 'Is Not Empty' },
  { value: 'is_empty', label: 'Is Empty' },
  { value: 'contains', label: 'Contains' },
];

// Predefined dropdown lists that admins can choose from
export const PREDEFINED_LISTS = {
  year_of_study: {
    label: 'Year of Study',
    options: ['1st Year', '2nd Year', '3rd Year', '4th Year', '5th Year+', 'Graduate']
  },
  provinces: {
    label: 'Canadian Provinces',
    options: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon']
  },
  scholarship_type: {
    label: 'Scholarship Type',
    options: ['First Year', 'Continuing Education', 'Graduate Studies', 'Post-Graduate']
  },
  gender: {
    label: 'Gender',
    options: ['Male', 'Female', 'Non-binary', 'Prefer not to say']
  },
  education_level: {
    label: 'Education Level',
    options: ['High School', 'College', 'Undergraduate', 'Graduate', 'Post-Graduate', 'Doctorate']
  },
  yes_no: {
    label: 'Yes/No',
    options: ['Yes', 'No']
  },
  ahepa_organizations: {
    label: 'AHEPA Organizations',
    options: ['AHEPA', 'Daughters of Penelope', 'Sons of Pericles', 'Maids of Athena']
  }
};

// Predefined templates for repeatable groups
export const REPEATABLE_GROUP_TEMPLATES = {
  family_member: {
    label: 'Family Member with Affiliation',
    description: 'Add family members with their AHEPA organization affiliation',
    sub_fields: [
      { id: 'name', label: 'Family Member Name', type: 'text', required: true },
      { id: 'relationship', label: 'Relationship', type: 'text', required: false, placeholder: 'e.g., Father, Mother, Uncle' },
      { id: 'affiliation', label: 'AHEPA Affiliation', type: 'checkbox_group', options: ['AHEPA', 'Daughters of Penelope', 'Sons of Pericles', 'Maids of Athena'] }
    ]
  },
  education_history: {
    label: 'Education History',
    description: 'Add educational institutions attended',
    sub_fields: [
      { id: 'institution', label: 'Institution Name', type: 'text', required: true },
      { id: 'degree', label: 'Degree/Program', type: 'text', required: false },
      { id: 'start_year', label: 'Start Year', type: 'text', required: false },
      { id: 'end_year', label: 'End Year', type: 'text', required: false }
    ]
  },
  reference: {
    label: 'Reference/Recommender',
    description: 'Add references or recommenders',
    sub_fields: [
      { id: 'name', label: 'Name', type: 'text', required: true },
      { id: 'title', label: 'Title/Position', type: 'text', required: false },
      { id: 'organization', label: 'Organization', type: 'text', required: false },
      { id: 'email', label: 'Email', type: 'email', required: false },
      { id: 'phone', label: 'Phone', type: 'text', required: false }
    ]
  },
  custom: {
    label: 'Custom Group',
    description: 'Define your own sub-fields',
    sub_fields: []
  }
};